var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<form name=\"vm.detailForm\"><div flex=\"flex\" layout=\"row\"><div flex=\"80\" align-content=\"flex-start\" layout=\"column\"><div layout=\"row\"><div flex=\"48\" class=\"form-group\"><label for=\"companyName\" class=\"control-label\">Company Name </label><input ng-model=\"vm.docSvc.doc.companyName\" class=\"form-control\"/></div><div flex=\"48\" class=\"form-group\"><label for=\"companyStatus\" class=\"control-label\">Status</label><input ng-model=\"vm.docSvc.doc.accountState\" class=\"form-control\"/></div></div></div></div></form>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/administration/settings/tabs/topPanel.jade
// module id = 170
// module chunks = 0